import { COLORS } from 'constants/colors';

import styled from 'styled-components';

export const GlobalStyle = styled.div`
    cursor: default;
    background-color: ${COLORS.background};
`;
